import ReduxStore from '../ReduxStore';
import Environments from '../constants/environments';

export const getAssetDomainLegacy = (fileName = '') => {
    const assetDomain = 'https://content.rpdata.com/crux';
    const env = window.ENV.APP_ENV || Environments.PROD;
    const envPaths = {
        [Environments.UAT]: 'uat',
        [Environments.PROD]: 'prod',
        [Environments.DEV]: 'dev',
        [Environments.NON_PROD]: 'dev',
    };
    const envPath = envPaths[env] || 'dev';
    return `${assetDomain}/${envPath}/crux_assets/${fileName}`;
};

export const getAssetDomain = (pathFromAsset = '') => {
    const s3BaseUri = ReduxStore?.getState?.()?.settings?.aws?.s3BaseUri || 'https://crux-assets.corelogic.asia';
    return `${s3BaseUri}/assets/ui${pathFromAsset}`;
};

export default {
    getAssetDomain,
    getAssetDomainLegacy,
};